import Ajax from './Ajax'

const Notification = {
  getNotifications: (page = 1, pageSize = 20) => {
    return Ajax.get(`/notifications?page=${page}&pageSize=${pageSize}`)
  },
  getUnreadCount: () => {
    return Ajax.get('/notifications/unread-count')
  },
  markRead: (id) => {
    return Ajax.post(`/notifications/${id}/read`, {})
  },
  markAllRead: () => {
    return Ajax.post('/notifications/read-all', {})
  }
}

export default Notification
